import { ClientModel } from './client.model';
import { OwnerModel } from './owner.model';

export class UserLoginModel {

    accountId?: number | null;
    username?: string | null;
    password?: string | null;
    confirmedPassword?: string | null;
    userGuid?: string | null;
    applicationGuid?: string | null;
    authenticated?: boolean | null;
    clientList?: ClientModel[] | null;
    currentClient?: ClientModel | null;
    owner?: OwnerModel | null;
    active?: boolean | null;
    isPermitHolder?: boolean | null;
	grant_type?: string | null;

	constructor() {
		this.grant_type = 'password';
	}
}